import { useEffect, useState } from 'react';
import { CopyIconTwoTone } from '@room-match/shared-ui-components';
import { CopyAndShareContainer } from './CopyAndShare.styles';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { PiShareFat } from 'react-icons/pi';

const CopyAndShare = ({ textToCopy }: { textToCopy: string }) => {
  const [copySuccess, setCopySuccess] = useState<string>('');
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopySuccess('Copied to clipboard!');
    } catch (err) {
      setCopySuccess('Failed to copy!');
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopySuccess('');
    }, 2000);

    return () => clearTimeout(timer);
  }, [copySuccess]);

  return (
    <CopyAndShareContainer>
      <Tooltip title={copySuccess ? 'Copied!' : 'Copy link'}>
        <IconButton style={{ fontSize: 16, padding: 0 }}>
          <CopyIconTwoTone style={{ cursor: 'pointer' }} fontSize="inherit" onClick={handleCopy} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Coming Soon" aria-label="add">
        <Typography style={{ marginTop: 7, cursor: 'pointer', opacity: 0.2 }}>
          <PiShareFat fontSize={20} />
        </Typography>
      </Tooltip>
    </CopyAndShareContainer>
  );
};

export default CopyAndShare;
